import { SelfTransitionEventType, TransitionEventType } from "@/models/time-control/timeStateTypes";

export const TimeEventType = { ...TransitionEventType, ...SelfTransitionEventType };
